import ViewManager from './util/ViewManager'
import StoreHelper from './store/helper'

const api = {
  createView: ViewManager.createView,
  createParentView: ViewManager.createParentView,
  createChildView: ViewManager.createChildView,
  viewExists: ViewManager.viewExists,
  getActiveMenuItem: ViewManager.getActiveViewItem,
  // getActiveView: StoreHelper.getActiveView,
  // getActiveViewData: StoreHelper.getActiveViewData,
  // setMainView: StoreHelper.setMainView,
  addItemsToView: ViewManager.addItemsToView,
  removeItemFromView: ViewManager.removeItemFromView,
  replaceOrAddItemInView: ViewManager.replaceOrAddItemInView,
  canCreateView: StoreHelper.canCreateView,
  isHomeView: StoreHelper.isHomeView
}

export default api
